// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/typography/style/index.less
// module id = 566
// module chunks = 0